import Tooltip from 'vue-directive-tooltip';
import _ from 'lodash';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
import injectIntoTranslation from '../lib/Translate';

/**
 * Used to bootstrap the root Vue element.
 *
 * This code works with the rest of your bundle and requires the existence
 * of `window.lang` and `window.YourPageBundle` on the page. This is currently
 * facilitated with `layout/bundle.mustache`.
 *
 * @param {string} id       Id of html element Vue should attach to
 * @param {string} library  Name of the single page component
 * @param {Object} data     Props that should be passed to the single page component
 */
export default function bootstrap(id, library, data) {
  // Initialize window.lang if it doesn't exist (for pages without translated content)
  if (!window.lang) {
    window.lang = {};
  }

  window.t = function t(key, translationData = undefined) {
    const string = window.lang[key];

    if (string === undefined) {
      if (window.console && window.console.warn) {
        window.console.warn('Missing translation for', key);
      }

      return '';
    }

    return injectIntoTranslation(string, translationData, _.endsWith(key, '_html'));
  };

  /**
   * Allow v-tooltip
   */
  window.Vue.use(Tooltip, {
    delay: 0,
    placement: 'bottom',
  });

  /**
   * Allow `this.t` as translation function inside of Vue components
   */
  window.Vue.mixin({
    methods: {
      t: window.t,
    },
  });

  const pageModule = window[library];
  const pageComponent = pageModule && pageModule.default ? pageModule.default : pageModule;

  window.SinglePageComponent = new window.Vue({
    el: id,
    render(h) {
      return h(pageComponent, {
        props: {
          data,
        },
      });
    },
  });
}
